import { render, staticRenderFns } from "./PointsGoodWindow.vue?vue&type=template&id=ec2d5bf4"
import script from "./PointsGoodWindow.vue?vue&type=script&lang=js"
export * from "./PointsGoodWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports